import {Component, input, signal} from '@angular/core';
import {Card} from 'primeng/card';
import {Tab, TabList, TabPanel, TabPanels, Tabs} from 'primeng/tabs';
import {TranslocoPipe} from '@jsverse/transloco';
import {TabStatusEnum} from '../../../../../shared/tabs/tab-status.model';
import {TenderRfqProposalParametersComponent} from '../tender-rfq-2-proposal-parameters/tender-rfq-proposal-parameters.component';
import {TenderRfqGuidanceComponent} from '../tender-rfq-3-guidance/tender-rfq-guidance.component';
import {TenderRfqProposalSystemIntegrationComponent} from '../tender-rfq-25-system-integration/tender-rfq-proposal-system-integration.component';
import {TenderDetailResponse} from '@frontend/shared';
import {TabStatusDirective} from '../../../../../shared/tabs/tab-status.directive';
import {TabsUnsavedRevealDirective} from '../../../../../shared/tabs/tabs-unsaved-reveal.directive';

@Component({
  selector: 'app-tender-project-description-rfq',
  imports: [
    Card,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    TranslocoPipe,
    TenderRfqProposalParametersComponent,
    TenderRfqGuidanceComponent,
    TenderRfqProposalSystemIntegrationComponent,
    TabStatusDirective,
    TabsUnsavedRevealDirective,
  ],
  templateUrl: './tender-description-rfq.component.html',
})
export class TenderDescriptionRfqComponent {
  readonly tenderDetails = input.required<TenderDetailResponse>();

  protected readonly tabStatus = signal(TabStatusEnum.COMPLETED);
  protected readonly activeTabIndex = signal(0);

  protected onTabChange(index: number | string): void {
    this.activeTabIndex.set(Number(index));
  }
}
